var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatSendMessageDisableIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.068,
    viewBox: "0 0 24 21.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M39.031,57.081l-.008,0L17.668,48.106a1.165,1.165,0,0,0-1.111.109A1.253,1.253,0,0,0,16,49.258V55a1.212,1.212,0,0,0,.976,1.194L28.624,58.37a.2.2,0,0,1,0,.4L16.977,60.95A1.211,1.211,0,0,0,16,62.143v5.739a1.2,1.2,0,0,0,1.191,1.2,1.214,1.214,0,0,0,.476-.1l21.355-8.92.01,0a1.629,1.629,0,0,0,0-2.978Z",
    transform: "translate(-16 -48.013)",
    fill: "#a9a9a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatSendMessageDisableIcon);
export default __webpack_public_path__ + "static/media/live-chat-send-message-disable-icon.4a6b555b15d79b52dc70954639c778ff.svg";
export { ForwardRef as ReactComponent };